import {useQuery} from '@tanstack/react-query'
import {getCreatorProfile} from '../services/guest.http'
import {QUERY_KEYS} from './keys'

export const useGetCreatorProfile = ({creatorIdentifier}: {creatorIdentifier: string | null}) => {
    return useQuery({
        queryKey: [QUERY_KEYS.host_profile, creatorIdentifier],
        queryFn: () => getCreatorProfile(creatorIdentifier as string),
        enabled: Boolean(creatorIdentifier)
    })
}
